<template xmlns="http://www.w3.org/1999/html">
    <!--<tbody>-->
    <span style="display: contents;">
        <tr class="userrow" @click="expanded = !expanded">
            <UserCell :worklogsView = true class="user-td" :userId="userId"></UserCell>
            <template v-for="(logged, dateIndex) in logs.total">
                <td v-if="dateIndex <= actualDate" v-bind:key="dateIndex" class="table-data">
                    <div
                            class="logged-number"
                            v-show="showHours"
                    >
                        {{(logged.time/3600).toFixed(2)}}
                    </div>
                    <div
                            v-show="showRateTime"
                            :class="{'zero-value': !logged.expenses}"
                            class="currency expenses-number"
                    >
                        {{numberWithSpaces((logged.expenses/3600).toFixed(2))}}
                    </div>
                </td>
                <td v-if="dateIndex >= actualDate" v-bind:key="dateIndex+'1'" :class="[dateIndex == actualDate ? 'curweek' : '', dateIndex > actualDate ? 'after-curweek' : '', dateIndex < actualDate ? 'before-curweek' : '']" class="table-data">
                     <WorklogsPlanningCell
                             :totalPlanned="plannedWorkloads[userId] && plannedWorkloads[userId][dateIndex] ? plannedWorkloads[userId][dateIndex] : totalPlanned"
                             v-if="showTotalPlanned"
                             :userId="userId"
                             :dateIndex="dateIndex"
                             :projectId="projectId"
                             :showWorkloadPlanner="showWorkloadPlanner"
                             :showPlannedExpenses="showPlannedExpenses"
                             :showTotalPlanned="showTotalPlanned"
                             :showRateTime="showRateTime"
                             :showHours="showHours"
                             :timeframe="timeframe"
                     ></WorklogsPlanningCell>
                </td>
            </template>
            <td v-if="utilization" class="table-data">
                <div class="logged-number">{{(totalSum.actual/3600).toFixed(2)}}</div>
            </td>
            <td v-if="utilization" class="table-data">
                <div>{{(logs.workload * workingHours).toFixed(2)}}</div>
            </td>
            <td v-if="utilization" class="table-data">
                <div>{{((totalSum.actual/3600) / (logs.workload * workingHours)).toFixed(2)}}</div>
            </td>
        </tr>
        <tr class="userrow projects" v-if="allowExpanding && expanded && showProjectRow(projectId)" v-for="(logged, projectId) in logs.byProject" v-bind:key="projectId+userId">
            <ProjectCell :worklogsView = true :projectId="projectId"></ProjectCell>
            <template v-for="(log, dateIndex) in logged">
                <td v-if="dateIndex <= actualDate" v-bind:key="dateIndex" class="table-data">
                    <div v-show="showHours" :class="{'zero-value': !log.time}">{{(log.time/3600).toFixed(2)}}</div>
                    <div v-show="showRateTime" :class="{'zero-value': !log.expenses}" class="currency">{{numberWithSpaces((log.expenses/3600).toFixed(2))}}</div>
                </td>
                <td v-if="dateIndex >= actualDate" v-bind:key="dateIndex+'1'" :class="[dateIndex == actualDate ? 'curweek' : '', dateIndex > actualDate ? 'after-curweek' : '', dateIndex < actualDate ? 'before-curweek' : '']"  class="table-data" >
                    <WorklogsPlanningCell
                            :totalPlanned="plannedWorkloads[userId] && plannedWorkloads[userId][dateIndex] ? plannedWorkloads[userId][dateIndex] : totalPlanned"
                            :plannedHoursByProject="true"
                            v-if="showTotalPlanned"
                            :userId="userId"
                            :dateIndex="dateIndex"
                            :projectId="projectId"
                            :showWorkloadPlanner="showWorkloadPlanner"
                            :showPlannedExpenses="showPlannedExpenses"
                            :showRateTime="showRateTime"
                            :showHours="showHours"
                            :showTotalPlanned="showTotalPlanned"
                            :timeframe="timeframe"
                    ></WorklogsPlanningCell>
                </td>
            </template>

            <td v-if="utilization" class="table-data before-curweek">
                <div class="logged-number">{{(totalSum.byProjects[projectId].actual / 3600).toFixed(2)}}</div>
            </td>
        </tr>
    </span>
    <!--</tbody>-->
</template>
<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import UserCell from './UserCell';
import ProjectCell from './ProjectCell';
import WorklogsPlanningCell from './WorklogsPlanningCell';
import Templates from '../documents/Templates';

export default {
  name: 'UserRow',
  props: [
    'userId',
    'projectId',
    'logs',
    'showRateTime',
    'showHours',
    'showWorkloadPlanner',
    'showPlannedExpenses',
    'showTotalPlanned',
    'allowExpanding',
    'timeframe',
    'plannedWorkloads',
    'utilization',
    'workingHours',
    'calendar'
  ],
  data: function () {
    return {
      expanded: false,
      totalPlanned: {
        totalPlanned: 0,
        totalCalculated: 0,
        totalExpenses: 0,
        plannedTimeFromTodayTillPeriodEnd: 0,
        projects: null
      },
      totalSum: {
        actual: 0,
        byProjects: {}
      }
    };
  },
  components: {
    Templates,
    UserCell,
    WorklogsPlanningCell,
    ProjectCell
  },
  watch: {
    logs: {
      handler: function () {
        this.calculateUtilization();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('Worklogs', ['curweek', 'actualDate', 'actualDateDay']),
    ...mapGetters('WorkloadPlans', [
      'workloadsByProjectByUserByYearweek',
      'workloads',
      'workloadsByUserByYearweekByProject',
      'workloadsByUserByMonthByProject',
      'workloadsByUserByQuarterByProject',
      'workloadsByUserByYearByProject',
    ]),
    ...mapGetters('Worklogs', [
      'datesByYearweek', 'weekOffset', 'weekCount', 'actualDate', 'curweek'
    ]),
    ...mapGetters('UserRates', [
      'ratesOnDate',
    ]),
    ...mapGetters('JiraProjects', [
      'projects',
    ]),
  },
  methods: {
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    showProjectRow(projectId) {
      if (this.projects[projectId].end_date >= '2018-01-01' || this.projects[projectId].change_requests_end_date >= '2018-01-01') {
        return true;
      }
      return false;
    },
    calculateSum() {
      let actual = 0;

      // total by worklogs
      for (const calendarItem in this.calendar) {
        const calendarIndex = this.calendar[calendarItem].index;
        const log = this.logs.total[calendarIndex];
        actual += log ? log.time : 0;
      }
      // total by planned
      if (typeof this.plannedWorkloads[this.userId] !== 'undefined') {
        for (const calendarIndex in this.logs.total) {
          if (
            typeof this.plannedWorkloads[this.userId][calendarIndex] !== 'undefined'
                            && this.actualDate <= calendarIndex
          ) {
            this.actualDate === calendarIndex
              ? actual += this.plannedWorkloads[this.userId][calendarIndex].plannedTimeFromTodayTillPeriodEnd
              : actual += this.plannedWorkloads[this.userId][calendarIndex].totalPlanned;
          }
        }
      }
      this.totalSum.actual = actual;
    },
    calculateProject() {
      const projectSum = {};
      for (const projectId in this.logs.byProject) {
        projectSum[projectId] = { actual: 0 };

        // total by project worklogs
        for (const worklogId in this.logs.byProject[projectId]) {
          const log = this.logs.byProject[projectId][worklogId];
          projectSum[projectId].actual += log.time;
        }

        // total byproject  planned worloads
        if (typeof this.plannedWorkloads[this.userId] !== 'undefined') {
          for (const calendarIndex in this.logs.total) {
            if (
              typeof this.plannedWorkloads[this.userId][calendarIndex] !== 'undefined'
                                && typeof this.plannedWorkloads[this.userId][calendarIndex] !== 'undefined'
                                && typeof this.plannedWorkloads[this.userId][calendarIndex].projects[projectId] !== 'undefined'
                                && this.actualDate <= calendarIndex
            ) {
              this.actualDate === calendarIndex
                ? projectSum[projectId].actual += this.plannedWorkloads[this.userId][calendarIndex].projects[projectId].plannedTimeFromTodayTillPeriodEnd
                : projectSum[projectId].actual += this.plannedWorkloads[this.userId][calendarIndex].projects[projectId].plannedTime;
            }
          }
        }
      }
      this.totalSum.byProjects = projectSum;
    },
    calculateUtilization() {
      this.calculateSum();
      this.calculateProject();
    }
  },
  mounted() {
    if (this.utilization) {
      this.calculateUtilization();
    }
  },
};
</script>
<style scoped>
    td {
        padding: 0.1rem;
        padding-right: 0.5rem;
        border-right: 1px solid #cfd8dc;
    }
    .currency::after{
        content: " €";
    }
    .curweek {
        /*background-color: #ffffff;*/
        border-left: 3px solid black;
    }
   /* .before-curweek {
        background-color: #ffffff;
    }
    .after-curweek {
        background-color: #ffffff;
    }*/
    .logged-number {
        color: crimson;
    }
    .table-data{
        text-align: right;
    }
    .zero-value{
        color: silver;
    }
    .userrow:hover {
        background-color: #efefef
    }
    tr.userrow.projects {
        border-left: 3px solid;
        background-color: #e2e2e2;
    }
    .projects {
        background-color: #f7f7f7;
    }
    tbody{
        border-top: none !important;
    }
    .expenses-number {
        color: darkgreen;
    }

    .user-td {
        font-size: 13px;
        padding-left: 10px;
        padding-top: 1px;
    }
    /*tr {*/
        /*width: 100%;*/
        /*display: inline-table;*/
        /*table-layout: fixed;*/

    /*}*/

    td.table-data.curweek > div {
        display: inline-block;
    }

    td.table-data.curweek > div:nth-of-type(2) {
        padding-left: 10px;
    }

    td.table-data.curweek > div:nth-of-type(2) {
        padding-left: 10px;
    }

</style>
